// extracted by mini-css-extract-plugin
export var formContainer = "_hc-0";
export var message = "_hc-1";